import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.link";
import "core-js/modules/web.dom-collections.iterator";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from "react";
import classnames from "classnames";
import withReduxProvider from "web/react/redux-provider";
import SecondaryButton from "web/react/components/buttons/secondary-button/secondary-button";
import PrimaryButton from "web/react/components/buttons/primary-button/primary-button";
import CookieSettingsContainer from "web/react/components/cookie-settings-container/cookie-settings-container";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import { useDispatch, useSelector as useReduxSelector } from "react-redux";
import { consentToAllCookies } from "web/redux/ducks/cookie-consent";
import history from "web/script/utils/history";
import { useOverlayWatcher } from "web/react/hooks/use-overlay-watcher/use-overlay-watcher";
import environment from "web/script/modules/environment";
import styles from "./cookie-banner.css";

function extractConsentState(state) {
  return state.cookieConsentReducer.consentConfirmed;
}

export function CookieBanner(_ref) {
  var cookiePolicyUrl = _ref.cookiePolicyUrl,
      debug = _ref.debug;
  var showCookieSettingsLink = environment.getFeature("mg_require_cookie_consent");
  var enhancedAcceptAll = environment.getFeature("mg_cookie_consent_larger_cta");

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showBanner = _useState2[0],
      setShowBanner = _useState2[1];

  var consentConfirmed = useReduxSelector(extractConsentState);
  var dispatch = useDispatch();

  function hideNotification() {
    setShowBanner(false);
    dispatch(consentToAllCookies());
    analytics.event("Cookie consent", "Clicked", "Hide");
  }

  useEffect(function () {
    if (debug || !consentConfirmed) {
      analytics.event("Cookie consent", "Shown", undefined, true);
      setShowBanner(true);
    } else {
      setShowBanner(false);
    }
  }, [debug, consentConfirmed]);
  var cookieText = gettext("cookie_notification.description_v2");
  var cookieSettingsModal = "cookie-settings-banner-modal";
  var settingsModalIsOpen = !!useOverlayWatcher(cookieSettingsModal);

  function onSettingsModalClose() {
    history.popOverlay(cookieSettingsModal);
  }

  function openSettingsModal() {
    // I check the current overlay state instead of modalIsOpen
    // to get around the delay introduced by hooks
    if (history.getCurrentState().overlay != cookieSettingsModal) {
      history.pushOverlay(cookieSettingsModal);
    }
  }

  function getAcceptButton() {
    if (enhancedAcceptAll && showCookieSettingsLink) {
      return React.createElement(PrimaryButton, {
        onClick: hideNotification,
        className: styles.acceptButton,
        fullWidth: true
      }, gettext("cookie_notification.cookie_settings.accept_all.cta"));
    } else if (enhancedAcceptAll && !showCookieSettingsLink) {
      return React.createElement(PrimaryButton, {
        onClick: hideNotification,
        className: styles.acceptButton,
        fullWidth: true
      }, gettext("general.accept"));
    }

    return React.createElement(SecondaryButton, {
      onClick: hideNotification,
      className: styles.acceptButton,
      fullHeight: true
    }, gettext("general.accept"));
  }

  var CookieSettings = React.createElement("div", {
    className: classnames(styles.cookieSettingsWrapper, _defineProperty({}, styles.inlineSettings, showCookieSettingsLink && enhancedAcceptAll))
  }, React.createElement(CookieSettingsContainer, {
    isOpen: settingsModalIsOpen,
    onModalClose: onSettingsModalClose
  }), React.createElement("a", {
    className: styles.link,
    onClick: openSettingsModal
  }, " ", // "Cookie Settings"
  gettext("cookie_notification.cookie_settings.title")));
  var ReadMoreLink = React.createElement("a", {
    className: styles.readMore,
    href: cookiePolicyUrl
  }, gettext("general.read_more"));
  return React.createElement(React.Fragment, null, showBanner && React.createElement("div", {
    className: classnames(styles.wrapper, _defineProperty({}, styles.wideWrapper, enhancedAcceptAll))
  }, React.createElement("div", {
    className: classnames(styles.container, _defineProperty({}, styles.wideContainer, enhancedAcceptAll))
  }, React.createElement("div", {
    className: classnames(styles.content, _defineProperty({}, styles.wideContent, enhancedAcceptAll))
  }, React.createElement("div", {
    className: styles.text
  }, cookieText, " ", (!showCookieSettingsLink || !enhancedAcceptAll) && ReadMoreLink, showCookieSettingsLink && enhancedAcceptAll && CookieSettings)), React.createElement("div", {
    className: classnames(styles.options, _defineProperty({}, styles.wideAcceptButton, enhancedAcceptAll))
  }, showCookieSettingsLink && !enhancedAcceptAll && CookieSettings, getAcceptButton()))));
}
export default withReduxProvider(CookieBanner);